import { Box, Typography, Stack, useTheme } from '@mui/material';
import { useContext } from 'react';
import { UserContext } from '../../../../shared/useUser';
import { getDisplayStoreNumber } from '../../../../../utils/storeNumber';
import { useUser as useClerkUser } from '@clerk/clerk-react';

const textClamp = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '1',
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-all',
};

export const StoreDisplay = (props: { onSwitchStore: () => void }) => {
  const theme = useTheme();
  const { selectedStore, stores } = useContext(UserContext);

  const storeNumber = getDisplayStoreNumber(selectedStore);
  const franchiseName = selectedStore?.franchiseName;
  let storeName = selectedStore?.storeName || '';

  if (storeName.indexOf('@') > -1) {
    const storeNameParts = storeName.split('@');

    storeName = storeNameParts[1];
  } else {
    storeName = storeName.replace(storeNumber, '');
  }

  storeName = storeName.replace(/^[\W]+/, '');

  const { user, isLoaded } = useClerkUser();

  if (!isLoaded || user == null) return null;

  const { hasImage, imageUrl, emailAddresses, firstName, lastName } = user;
  const params = new URLSearchParams();

  params.set('height', '200');
  params.set('width', '200');
  params.set('quality', '100');
  params.set('fit', 'crop');

  const imageSrc = `${imageUrl}?${params.toString()}`;

  return (<Box
    display='flex'
    marginBottom={'12px'}
    marginTop={'16px'}
    marginLeft={'6px'}
    marginRight={'6px'}
    alignItems='center'
    sx={{ cursor: (stores && stores.length > 1 ? 'pointer' : 'default') }}
    onClick={(e) => { props.onSwitchStore(); e.stopPropagation(); e.preventDefault(); }}
  >
    <Box sx={{ position: 'relative' }}>
      {hasImage ?
        <img src={`${imageSrc}`}
          height='50px'
          style={{ borderRadius: '50%' }}
          alt='avatar' /> :
        <Box
          sx={{
            width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            backgroundColor: theme.palette.primary[50], color: theme.palette.text.secondary,
            borderRadius: '50%', fontSize: '16px', fontWeight: 600,
          }}
        >{firstName && lastName ? `${firstName[0]}${lastName[0]}` : (emailAddresses?.[0]?.emailAddress?.[0] ?? '')}</Box>}
      <img src={`${theme.brandingImages.logoImage}`}
        height='20px'
        style={{ position: 'absolute', top: 30, right: 0, backgroundColor: 'white', borderRadius: '50%', padding: '2px', border: '1px solid black', borderColor: theme.palette.primary[400] }}
        alt='brand' />
    </Box>
    <Stack
      textAlign='left'
      marginLeft={'8px'}
      justifyContent='space-between'
    >
      <Typography
        color={theme.palette.primary.contrastText}
        variant='textXS'
        sx={{
          fontWeight: '300',
          ...textClamp,
        }}
      >
        {user ? emailAddresses?.[0]?.emailAddress ?? '' : 'No store selected'}
      </Typography>
      <Typography
        color={theme.palette.primary.contrastText}
        variant='textXS'
        sx={{
          fontWeight: '300',
          ...textClamp,
        }}
      >
        {storeName ? `${storeName}` : 'No store selected'}
      </Typography>
      <Typography
        color={theme.palette.primary.contrastText}
        variant='textXS'
        sx={{
          ...textClamp,
        }}>
        {franchiseName ? `${storeNumber} - ${franchiseName}` : 'No franchise selected'}
      </Typography>
    </Stack>

  </Box >);
};
